<template>
    <div>
        <archived-tariff
            v-if="tariff && !tariff.isActive"
            :tariff="tariff"
            :payed-till="payedTill"
            :expired="expired"
        />
        <tariff
            v-else-if="tariff && user"
            :user="user"
            :tariff="tariff"
            :payed-till="payedTill"
            :expired="expired"
            :tariff-percent="tariffPercent"
            :balance-in-days="balanceInDays"
            :promotion="promotion"
        />
        <tariff
            v-else-if="user"
            :user="user"
            :tariff="defaultTariff"
            :payed-till="payedTill"
            :expired="expired"
            :tariff-percent="tariffPercent"
            :promotion="promotion"
        />
    </div>
</template>

<script>
import {get, isEmpty} from 'lodash';

import TariffAPI from "../api/TariffAPI";
import UserApi from "../api/UserApi";
import ArchivedTariff from "./subscription/ArchivedTariff.vue";
import Tariff from "./subscription/Tariff.vue";

export default {
    name: "Subscription",
    props: {
        tariffPercent: {
            type: Array,
            required: true
        },
        balanceInDays: {
            type: Number,
            required: false,
            default: 0
        },
        promotion: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: () => ({
        user: null,
        tariff: null,
        defaultTariff: null,
    }),
    computed: {
        payedTill() {
            const timestamp = get(this.user, 'payedDate');
            return timestamp ? new Date(timestamp * 1000) : null;
        },
        expired() {
            return this.payedTill && (new Date()).getTime() >= this.payedTill.getTime()
        }
    },
    methods: {
        async init() {
            await Promise.all([
                this.loadDefaultTariff(),
                this.loadCurrentTariff(),
                this.loadUser(),
            ]);
        },
        async loadCurrentTariff() {
            const tariff = await TariffAPI.getCurrent()
            this.tariff = !isEmpty(tariff) ? tariff : null;

        },
        async loadDefaultTariff() {
            const tariff = await TariffAPI.getDefault()
            this.defaultTariff = !isEmpty(tariff) ? tariff : null;
        },
        async loadUser() {
            this.user = await UserApi.getCurrent();
        },
    },
    created() {
        this.init();
    },
    components: {
        ArchivedTariff,
        Tariff,
    },
}
</script>
